export interface Payment {
    paymentID?: number;
    value: number;
    date: Date;
    payee: string;
    eventID?: number;
    bookingID?: number;
    accountID?: number;
    paymentProvider: PaymentProvider;
    paymentData: PaymentData[];
}

export interface PaymentProvider {
    paymentProviderID: number;
    name?: string;
}

export interface PaymentProviderField{
    paymentProviderFieldID: number;
    paymentProviderID: number;
    name: string
}

export interface PaymentData {
    paymentID?: number;
    paymentProviderFieldID: number;
    name?: string;
    value: string;
}

export enum PaymentProviders {
    PayPal = 1, 
    Stripe = 2,
    BankTransfer = 3,
    Cash = 4
}

export enum PaymentProviderFields {
    OrderID = 1,
    PaymentID = 2,
    ReferenceID = 3
}